import { lazy, Suspense } from "react";
import Fallback from "../custom/fallback/fallback";
import DashboardLayout from "./dashboardLayout/dashboardLayout";
const Main = lazy(() => import('../components/profile/main'))

const Profile = () => {
    return (
        <DashboardLayout>
            <Suspense fallback={<Fallback />}>
                <Main />
            </Suspense>
        </DashboardLayout>
    )
}

export default Profile;